// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"L3-z"};